export const PREFIX_SALT = btoa('ovoc');
export const PENDING_MFA_SESSION_KEY = 'ac-wait';
